import { io, Socket } from "socket.io-client";
import type {
    Bar,
    LibrarySymbolInfo,
    ResolutionString,
    SubscribeBarsCallback,
} from "libraries/charting_library";

type SubscriptionItem = {
    subscriberUID: string;
    resolution: ResolutionString;
    lastBar: Bar;
    handlers: {
        id: string;
        callback: SubscribeBarsCallback;
    }[];
    pairIndex: number;
};

export const channelToSubscription = new Map<string, SubscriptionItem>();


// barTime is millisec, resolution is mins
export const  getNextBarTime=(barTime: number, resolution: number) => {
    const previousSegment = Math.floor(barTime / 1000 / 60 / resolution);
    return (previousSegment + 1) * 1000 * 60 * resolution;
}

export function subscribeOnStream(
    socket: Socket,
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    onRealtimeCallback: SubscribeBarsCallback,
    subscriberUID: string,
    onResetCacheNeededCallback: () => void,
    lastBar: Bar,
    pairIndex: number,
    token: string
) {
    try {
        if (!socket) {
            console.error("WebSocket is not initialized.");
            return;
        }
        const channelString = token;
        const handler = {
            id: subscriberUID,
            callback: onRealtimeCallback,
        };

        let subscriptionItem = channelToSubscription.get(channelString);
        if (subscriptionItem) {
            // Already subscribed to the channel, use the existing subscription
            subscriptionItem.handlers.push(handler);
            return;
        }
        // New subscription
        subscriptionItem = {
            subscriberUID,
            resolution,
            lastBar,
            handlers: [handler],
            pairIndex,
        };
        channelToSubscription.set(channelString, subscriptionItem);

        const subRequest = {
            action: 'SubAdd',
            subs: [channelString],
        };
        socket?.send(JSON.stringify(subRequest));
    } catch (error) {
        console.error("Error in subscribeOnStream:", error);

    }

}

export function unsubscribeFromStream(
    subscriberUID: string,
    socket: Socket,
    token: string
) {
    // Find a subscription with id === subscriberUID
    for (const pairIndex of channelToSubscription.keys()) {
        if (!socket) {
            console.error("WebSocket is not initialized.");
            return;
        }
        const subscriptionItem = channelToSubscription.get(pairIndex);
        if (!subscriptionItem) {
            continue;
        }

        const handlerIndex = subscriptionItem.handlers.findIndex(
            (handler) => handler.id === subscriberUID,
        );

        if (handlerIndex !== -1) {
            // Remove from handlers
            subscriptionItem.handlers.splice(handlerIndex, 1);

            if (subscriptionItem.handlers.length === 0) {
                // Unsubscribe from the channel if it was the last handler
                console.log(
                    "[unsubscribeBars]: Unsubscribe from streaming. Channel:",
                    pairIndex,
                );
                const subRequest = {
                    action: 'SubRemove',
                    subs: [pairIndex],
                };
                socket?.send(JSON.stringify(subRequest));
                channelToSubscription.delete(pairIndex);
                break;
            }
        }
    }
}
